export default "__VITE_ASSET__CWJBHrxN__"